export async function storeReflection(api, payload) {
  if (!payload?.original_text?.trim()) return null;
  try {
    const res = await api.post('/ai/reflections', payload);
    return res.data;
  } catch {
    return null;
  }
}
